import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineChangeDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    spaces
}: TimelineChangeDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
